export function hasDifference(
  obj1: Record<string, any> | null,
  obj2: Record<string, any> | null
): boolean {
  // Helper function to check if two values are different
  const isDifferent = (val1: any, val2: any): boolean => {
    if (val1 === null || val2 === null) {
      return val1 !== val2;
    }
    if (typeof val1 !== typeof val2) return true;
    if (typeof val1 === 'object') {
      return hasDifference(val1, val2);
    }
    return val1 !== val2;
  };

  // If either obj1 or obj2 is null, they are only equal if both are null
  if (obj1 === null || obj2 === null) {
    return obj1 !== obj2;
  }

  // Iterate over the keys of the first object
  for (const key in obj1) {
    if (Object.prototype.hasOwnProperty.call(obj1, key)) {
      if (
        !Object.prototype.hasOwnProperty.call(obj2, key) ||
        isDifferent(obj1[key], obj2[key])
      ) {
        return true;
      }
    }
  }

  // Iterate over the keys of the second object to catch keys not in the first object
  for (const key in obj2) {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      if (!Object.prototype.hasOwnProperty.call(obj1, key)) {
        return true;
      }
    }
  }

  // If no differences were found, return false
  return false;
}
